import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { History } from 'history'

import { selectUser } from '../../../reducers'
import { createAddress, fetchUser } from '../userActions'
import { UserBanner } from '../userBanner'
import UserAddressForm from './userAddressForm'
import { User } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  createAddress: Callback<Promise<any>>
  fetchUser: Callback
  user: User
  match: Match<ParamsID>
  history: History
}

export class UserAddressNew extends Component<Props> {
  static displayName = 'UserAddressNew'

  componentWillMount() {
    const { fetchUser, match } = this.props
    fetchUser(match.params.id)
  }

  onSubmit = (values) => {
    const { createAddress, user, history } = this.props
    const createAddressInput = Object.assign({}, { userId: user.id }, values)
    return createAddress(createAddressInput, user).then(() => {
      history.goBack()
    })
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const { user } = this.props
    if (isEmpty(user)) return null

    return (
      <div className="create-address">
        <UserBanner address={user.currentAddress} context="User" user={user} />
        <UserAddressForm
          onSubmit={this.onSubmit}
          cancel={this.onCancel}
          title="Add an Address"
        />
      </div>
    )
  }
}

export const mapStateToProps = (state, { match }) => {
  return {
    user: selectUser(state.users, match.params.id),
  }
}

export default connect(mapStateToProps, { fetchUser, createAddress })(
  UserAddressNew
)
